import Model from "../Model";

export default class extends Model {
    async loadTable(
      page,
      per_page,
      search = '',
      brand_id = null,
      client_id = null,
      device_type_id = null,
      device_os_id = null,
      device_version_id = null,
      date = null,
      currentSortColumn = null,
      currentSortOrder = null
    ) {
        let lastPage = 1;
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                per_page,
                search,
                brand_id,
                client_id,
                device_type_id,
                device_os_id,
                device_version_id,
                date,
                currentSortColumn,
                currentSortOrder
            }
        }).then(response => {

            lastPage = response.data.meta.last_page;

            if(response.data.data !== undefined)
            {
                if(response.data.data.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: lastPage,
        };

        if(response.data !== undefined && response.data.length > 0)
        {
            response.data.forEach(install_log => {
                let telem = {
                    tbody: {}
                };
                telem.id = install_log.id;
                telem.tbody.completed_at = install_log.completed_at;
                telem.tbody.finished_at = install_log.finished_at;
                telem.tbody.error_log_path = install_log.error_log_path;
                telem.tbody.version_number = install_log.device_deployment_assignment.device_release.device_software_version.full_version;
                telem.tbody.status_description = install_log.status.description;
                telem.tbody.status_color = install_log.status.color;
                telem.tbody.location_number = install_log.device_deployment_assignment.device.location.number;
                telem.tbody.brand = install_log.device_deployment_assignment.device.location.brand.name;
                telem.tbody.client = install_log.device_deployment_assignment.device.location.client.name;
                telem.tbody.device_type = install_log.device_deployment_assignment.device.type.name;
                telem.tbody.os = install_log.device_deployment_assignment.device.device_operating_system.name;
                telem.tbody.device_ip = install_log.device_deployment_assignment.device.ip;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
